import React, { useState, useEffect } from 'react';
import { Grid, Button, Typography, FormControl, FormLabel, FormControlLabel, FormGroup, Checkbox, Collapse, Icon } from '@mui/material';
import FilterIcon from '@mui/icons-material/FilterList';
import { get, set } from 'global/lib/lodash';
import { useScreen } from 'global/styles';
import useStyles from 'global/styles/filters';
import DiagContainer from 'global/components/diag-container';

export default function PerformLibraryFilters({ config, onChange, renderFilterChips }) {
  const [showFilters, setShowFilters] = useState(false);
  const [closed, setClosed] = useState({});

  const { isMobile } = useScreen();

  const classes = useStyles();

  useEffect(() => {
    setShowFilters(!isMobile);
  }, [isMobile]);

  const onFilterChange = (parent, child, event) => {
    const conf = { ...config };
    const location = [parent, 'data', child, 'value'];
    const currentValue = get(config, location);
    set(conf, location, !currentValue);
    onChange(conf);
  };

  function toggleFilters() {
    setShowFilters(!showFilters);
  }

  const toggleClosed = (conf) => {
    setClosed({
      ...closed,
      [conf.title]: !get(closed, conf.title, true),
    });
  };

  return (
    <div className={classes.grid}>
      {isMobile && (
        <div className={classes.filterRow}>
          <Button className="FilterBtn" aria-label="filters" size="small" onClick={toggleFilters}>
            <FilterIcon fontSize="inherit" className={classes.icon} /> {showFilters ? 'Hide Filters' : 'Filters'}
          </Button>
          {renderFilterChips && renderFilterChips()}
        </div>
      )}

      <DiagContainer useDialog={isMobile} onClose={toggleFilters} open={showFilters}>
        <Typography variant="overline">Filters</Typography>

        <form autoComplete="off" margin="normal" className={showFilters ? '' : classes.hidden}>
          <Grid container>
            {Object.keys(config).map((k) => {
              const conf = config[k];
              const data = get(conf, 'data', {});
              const open = get(closed, conf.title, true);
              const show = get(conf, 'canShow', () => true)(conf);

              return !show ? null : (
                <Grid item xs={12} className={classes.formGrid}>
                  <FormControl component="fieldset" className={classes.formItem}>
                    <FormLabel style={{ cursor: 'pointer', display: 'flex', flexDirection: 'row', alignItems: 'center' }} onClick={() => toggleClosed(conf)} component="legend">
                      {conf.title}
                      <Icon>{open ? 'arrow_drop_down' : 'arrow_right'}</Icon>
                    </FormLabel>
                    <Collapse in={open}>
                      <FormGroup>
                        {Object.keys(data).map((dk) => {
                          const item = get(data, dk, {});
                          const val = get(data, [dk, 'value'], 0);
                          return (
                            <FormControlLabel
                              key={dk}
                              control={<Checkbox checked={!!val} onChange={(e) => onFilterChange(k, dk, e)} value={val} />}
                              label={
                                <div className={classes.checkRow}>
                                  {item.icon && <div className={classes.checkIcon}>{item.icon}</div>}
                                  {item.name}
                                </div>
                              }
                            />
                          );
                        })}
                      </FormGroup>
                    </Collapse>
                  </FormControl>
                </Grid>
              );
            })}
          </Grid>
        </form>
      </DiagContainer>
    </div>
  );
}
